import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

import lang from 'dojo/_base/lang';

import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';

import template from './Uploader.html?raw';
import _MandatoryMixin from '../../Controls/_MandatoryMixin/_MandatoryMixin';

class Uploader extends compose(_WidgetBaseSP, _MandatoryMixin) {
    [key: string]: any;

    templateString: any = template;

    onCompleteCallback: any = function (response: any) { };
    _lastUploadResponse: any = null;
    multiple = true;

    iconStatusOk = '<i class="fa fa-check w3-text-green" aria-hidden="true"></i>';
    iconStatusError = '<i class="fa fa-times w3-text-red" aria-hidden="true"></i>';

    constructor(params: any) {
        super(...(arguments as unknown as []));
        lang.mixin(this, params);


    }

    _setMultipleAttr(value: any) {
        this.multiple = value;

        domAttr.set(this.file1, "multiple", this.multiple);
    }

    _getMultipleAttr() {
        return this.multiple;
    }

    _setCallbackAttr(callback: any) {
        this.onCompleteCallback = callback;
    }

    _getValueAttr() {
        return this._lastUploadResponse;
    }

    _uploadFile(evt: any) {
        var formdata = new FormData();

        for (var i = 0; i < this.file1.files.length; i++) {
            formdata.append("files", this.file1.files[i]);
        }

        var ajax: any = new XMLHttpRequest();
        ajax.withCredentials = true;
        ajax.upload.addEventListener("progress", lang.hitch(this, "_upload_progressHandler"), false);
        ajax.addEventListener("load", lang.hitch(this, "_upload_completeHandler"), false);
        ajax.addEventListener("error", lang.hitch(this, "_upload_errorHandler"), false);
        ajax.addEventListener("abort", lang.hitch(this, "_upload_abortHandler"), false);
        ajax.onloadend = lang.hitch(this, function () {
            if (ajax.status == 404 || ajax.status == 500)
                lang.hitch(this, "_upload_errorHandler")();
        });

        ajax.open("POST", window.appRoot + "filetransfer/upload");

        ajax.send(formdata);
    }

    _upload_progressHandler(event: any) {
        this.loaded_n_total.innerHTML = "Uploaded " + event.loaded + " bytes of " + event.total;
        var percent = (event.loaded / event.total) * 100;
        this.progressBar.value = Math.round(percent);
        this.status.innerHTML = Math.round(percent) + "% uploaded... please wait";

        this._progressVisible(true);
    }

    _upload_completeHandler(event: any) {
        this.status.innerHTML = this.iconStatusOk;
        this.progressBar.value = 0;

        this._progressVisible(false);

        this._lastUploadResponse = JSON.parse(event.target.responseText);
        this.onCompleteCallback(this._lastUploadResponse); // callback
        this.emit("complete", this._lastUploadResponse); // event // man darf beides verwenden ...
        this.emit("change", this._lastUploadResponse);

        this.checkValidity();
    }

    _upload_errorHandler(event: any) {
        this.status.innerHTML = this.iconStatusError;

        this.checkValidity();

        this._progressVisible(false);
    }

    _upload_abortHandler(event: any) {
        this.status.innerHTML = "Upload Aborted";
        this.checkValidity();

        this._progressVisible(false);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._progressVisible(false);
    }

    _progressVisible(visible: any) {
        domStyle.set(this.loaded_n_total, "display", (visible === true) ? "" : "none");
        domStyle.set(this.progressBar, "display", (visible === true) ? "" : "none");
    }

}
Uploader.prototype.declaredClass = 'more.Legacy.FileTransfer.Uploader';

export default mdsWidget(Uploader);
